import jQuery from 'jquery';
// import gsap from 'gsap';
// import ScrollTrigger from 'gsap/ScrollTrigger';

export function scrollTo(target) {
  // console.log("function scrollTo", target);
  // var $ = $ || jQuery, // added to see solve jquery issue
    // $container = $('html'),
    // $target = $(target);

//  console.log("function scrollTo jquery",$target);

  target.scrollIntoView({
    behavior: 'smooth',
    block: 'start',
    inline: 'start'
  });

}

export function scrollToSection($container, hash) {
  // review use of htis

  // console.log("function scrollToSection", $container, hash);


  // //review this - I'm not sureing anchors + probably not needed

  // var $ = $ || jQuery, // added to see solve jquery issue
  //   itemid = hash.substring(1),
  //   $innerListItem = $('[data-anchor-id="' + itemid + '"]');
  // ////https://github.com/barbajs/barba/issues/53 -- infor re hahs

  // // console.log("scroll to Section", itemid);
  // // // console.log("[data-anchor-id="' + itemid + ']");
  // // console.log("$container", $container);
  // // console.log('[data-anchor-id="' + itemid + '"]')

  // $container.animate({
  //   scrollTop: ($container.scrollTop() + $innerListItem.offset().top -  $container.offset().top )
  // }, 200);


} //scrollToSection

export function closeNavigation($container) {
  // console.log("START close navigation");
  if ($container.closest('body').find("#header.--toggle-is-on").length > 0) {
    $container.closest('body').find("#header .header__toggle").trigger("click");

  }
  // console.log("END close navigation");
} //closeNavigation($container)